import React from "react";
import { Divider } from "@mui/material";
import { makeStyles } from "tss-react/mui";
const useStyles = makeStyles()((theme) => ({
  topBar: {
    position: "sticky",
    zIndex: theme.zIndex.appBar,
    backgroundColor: "white",
    height: theme.custom.pageHeaderHeight,
    paddingLeft: theme.spacing(3),
    display: "flex",
    alignItems: "center"
  }
}));
function TopBar({ children }) {
  const { classes } = useStyles();
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: classes.topBar }, children), /* @__PURE__ */ React.createElement(Divider, null));
}
export {
  TopBar,
  useStyles
};
//# sourceMappingURL=TopBar.js.map
